<!--
    @name: 筛选条件所在地组件
    @description:v2.0.10新增全国选项
    @time: 2022-07-18 11:40:33
-->
 <template>
  <div class="AF-area">
    <div v-if="laborAddress" class="AF-area-label">注册地区</div>
    <div v-else class="AF-area-label">所在地区</div>
    <div
      ref="country"
      class="AF-area-value-all"
      v-if="IsDefault"
      :class="{ overflowExpend: overflowExpend }"
    >
      <div
        class="AF-area-tag"
        :class="{ 'area-tag-active': active == '' }"
        @click="handleProvince()"
        ref="allprovince"
      >
        全国
      </div>
      <div
        class="AF-area-tag"
        :class="{ 'area-tag-active': active == item.id }"
        v-for="(item, index) in areaAll"
        :key="index"
        @click="handleProvince(item)"
      >
        {{ item.shortName }}
      </div>
    </div>
    <div
      class="AF-area-value"
      v-else
      :class="{ overflowExpend: overflowExpend }"
      ref="address"
    >
      <div class="AF-area-province">
        <el-popover
          placement="bottom-start"
          popper-class="myPopover"
          :width="310"
          :offset="-150"
          trigger="hover"
          :open-delay="100"
          :close-delay="100"
          @show="() => (provinceShow = true)"
          @hide="() => (provinceShow = false)"
        >
          <!-- 当前显示省份 -->
          <div slot="reference" class="popover-area">
            {{ provinceName }}
            <i
              :class="[
                provinceShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              ]"
            ></i>
          </div>
          <span class="popover-tag" @click="handleProvince()">全国</span>
          <span
            class="popover-tag"
            v-for="(item, index) in areaOther"
            @click="handleProvince(item)"
            :key="index"
            >{{ item.shortName }}</span
          >
        </el-popover>
      </div>
      <div class="AF-area-city" ref="city">
        <newAreaList
          class="AF-city"
          v-for="item in areaList"
          :key="item.no"
          :province="provinceName"
          :area="item"
          @click="submitArea"
        />
      </div>
    </div>
    <div
      class="AF-area-more"
      v-if="addressIsOpen"
      @click="isAddressIsOpen = !isAddressIsOpen"
    >
      <span v-show="isAddressIsOpen" class="isExpend">
        收起 <i class="el-icon-arrow-up"></i>
      </span>
      <span v-show="!isAddressIsOpen">
        展开 <i class="el-icon-arrow-down"></i>
      </span>
    </div>
  </div>
</template> 

<script>
import cookie from "@/storage/cookies"
import localStorage from "@/storage/localStorage"
import { apiPopularityTeam } from "@/api/apiPopularityTeam"
import apiUser from "@/public/apiUser/apiUser"
import {getPosition} from '@/storage/NewmapPosition.js'
export default {
  name: "locationAddress",
  props: {
    laborAddress: {
      type: Boolean,
      default: false
    },
  },
  components: {
    newAreaList: () => import("./newAreaList")
  },
  data() {
    return {
      IsDefault: false,
      active:"",
      //当前鼠标活动的市名字
      activeCityName: "",
      //当前选中省份下市区列表
      areaList: [],
      //当前选中区
      checkedCities: [],
      checkedCitiesbf: [],
      //当前选中市区
      formarea: {},
      //当前省id
      provinceId: "",
      //当前省名称
      provinceName: "",
      //是否需要显示展开按钮
      addressIsOpen: false,
      //是否展开市区
      isAddressIsOpen: false,
      //是否展开省
      provinceShow: false,
      areaAll:[],
      areai:[]
    }
  },
   async mounted() {
      this.getallArea()
      if (
        cookie.cookieRead("area") &&
        JSON.stringify(cookie.cookieRead("area")) !== "{}"
      ) {
        let area = cookie.cookieRead("area")
        this.areai = JSON.parse(area)
      }else{
        let mapAddr = null;
        mapAddr =await getPosition();
        this.areai= this.areaAll.find(item => {
          if (item.areaName.indexOf(mapAddr.address.province.substr(0, 2)) !== -1) {
            return item;
          }
        })
      }
      this.$parent.$refs.screen.locationAddresscode.provinceId = this.areai.id
      this.getClickLocation(this.areai)
  },
  computed: {
    overflowExpend({ addressIsOpen, isAddressIsOpen }) {
      if (addressIsOpen && !isAddressIsOpen) return true
      return false
    },
    // areai:function () {
    //   //默认地址
    //   // return JSON.parse(cookie.cookieRead("area"))
    // },
    // areaAll: function () {
    //   //所有省份
    //   return JSON.parse(localStorage.read("areaAll"))
    // },
    areaOther({ areaAll, active }) {
      //除了选中以外的其它省
      let province = areaAll.filter(vo => vo.id !== active)
      return province
    }
  },
  methods: {
    getallArea() {
      if(localStorage.read("areaAll")){
        this.areaAll=JSON.parse(localStorage.read("areaAll"))
      }else{
        apiUser.getArea().then(res => {
          if (res.data.code === 200) {
            this.areaAll=res.data.data
          }
        })
      }
    },
    // 点击后根据父级ID获取市区数据
    async getClickLocation(item) {
      this.provinceId = item.id
      this.provinceName = item.shortName
      if (!this.$store.state["HC_province" + item.id]) {
        let res = await apiPopularityTeam.getAreaById1(this.provinceId)
        //由于后期需要判断选择哪个区，给每个区加个属性checked
        res.data.data.map(v => {
          if(v.children){
            v.children && v.children.map(j => (j.checked = false))
            v.childrenbf = JSON.parse(JSON.stringify(v.children))
          }else{
            //单独处理澳门
            v.children && v.children.map(j => (j.checked = false))
          }
        })
        this.areaList = res.data.data
        this.$store.state["HC_province" + item.id] = res.data.data
      } else {
        this.areaList = this.$store.state["HC_province" + item.id]
      }
      this.isAddressIsOpen = true
      this.getWidthCity(this.areaList)
    },
    // 通过数组长度判断是否显示展开
    getWidthCity(data) {
      // 容器总宽度
      let allWidth = this.$refs.city.clientWidth
      // 数组长度
      let len = data.length
      // 文字总长度
      let textlen = data.map(item => item.name).join("").length
      // 内容宽度
      let width = 40 * len + 14 * textlen
      if (width > allWidth) {
        this.addressIsOpen = true
        this.isAddressIsOpen = false
      } else {
        this.addressIsOpen = false
      }
    },
    // @name 省的点击方法
    handleProvince(item) {
    //点其它省份
      if (item) {
        this.IsDefault = false
        this.checkedCities = []
        this.active=item.id
        this.getClickLocation(item)
        this.$parent.$refs.screen.locationAddresscode.provinceId = item.id
        this.$parent.$refs.screen.locationAddresscode.cityId = ""
        this.$parent.$refs.screen.locationAddress = []
      } else {
        //点全国
        this.IsDefault = true
        this.checkedCities = []
        this.active=""
        this.$parent.$refs.screen.locationAddresscode.provinceId = ""
        this.$parent.$refs.screen.locationAddresscode.cityId = ""
        this.$parent.$refs.screen.locationAddress = []
        this.$nextTick(function () {
          this.addressIsOpen = true
          this.isAddressIsOpen = !true
          this.provinceShow = !true
        })
      }
    },
    // 地区确认
    submitArea() {
      this.$parent.$refs.screen.locationAddresscode.provinceId =this.provinceId
    },
    // 清除单项
    close(item) {
      let index = ""
      this.checkedCities.map((v, i) => {
        if (v.no == item.no) {
          v.checked = false
          index = i
        }
      })
      this.checkedCities.splice(index, 1)
      this.checkedCitiesbf = [...this.checkedCities]
    },
    // 清空所有
    closeall() {
      this.checkedCitiesbf = []
      this.checkedCities = []
    }
  },
}
</script>


<style lang="scss" scoped>
.AF-area {
  margin: 0 auto;
  width: 1198px;
  font-size: 14px;
  line-height: 46px;
  display: flex;
  z-index: 300;
  border: 1px solid #e4e7ed;
  border-top: none;
  .AF-area-label {
    background: #f5f7fa;
    text-align: center;
    width: 130px;
    // height: 46px;
    color: #666666;
  }
  .AF-area-value {
    flex: 1;
    background: #ffffff;
    display: flex;
    .AF-area-city {
      flex: 1;
      width: 0;
    }
    .AF-area-tag {
      padding: 0 12px;
      display: inline-block;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      &.area-tag-active {
        color: #ffffff;
        background: #b79255;
        border-radius: 4px;
      }
    }
    .AF-city {
      display: inline-block;
      cursor: pointer;
    }
  }
  .AF-area-value-all {
    flex: 1;
    background: #ffffff;
    padding-left: 29px;
    padding-top: 5px;
    .AF-area-tag {
      display: inline-block;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      margin-right: 30px;
      &.area-tag-active {
        padding: 0 13px;
        color: #ffffff;
        background: #b79255;
        border-radius: 4px;
        margin-right: 17px;
        margin-left: -13px;
      }
    }
    .AF-city {
      display: inline-block;
      cursor: pointer;
    }
  }
  .overflowExpend {
    height: 46px;
    overflow: hidden;
  }
  .AF-area-more {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    background: #ffffff;
    padding-right: 10px;
    // padding-top: 5px;
    cursor: pointer;
    &:hover {
      color: #ff6600;
    }
  }
}
.popover-area {
  color: #b79255;
  padding: 0 12px 0 28px;
  cursor: pointer;
}
.popover-tag {
  display: inline-block;
  width: 58px;
  height: 24px;
  line-height: 24px;
  margin-bottom: 3px;
  padding: 0px 6px;
  cursor: pointer;
  &:hover {
    color: #b79255;
  }
}
/deep/ .el-popover {
  margin-top: 0 !important;
}
</style>
<style lang="scss">
.el-popover.myPopover {
  margin-top: -5px !important;
}
</style>
